import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store';
import { hostRouter } from './router-host'; // 主办路由 
import { tianbaoRouter } from './router-tianbao'; // 填报 - 中文
import { tianbaoRouterEn } from './router-tianbao-en'; // 填报 - 英文
const originalPush = Router.prototype.push;
Router.prototype.push = function push (location) {
  return originalPush.call(this, location);
  // .catch(err => err)
}



Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', redirect: '/fill/join/basic', name: '中国高等教育博览会' },
    ...hostRouter, 
    ...tianbaoRouter,
    ...tianbaoRouterEn,
  ]
});

// 路由守卫 
router.beforeEach((to, form, next) => {
  if (to.meta && to.meta.requireAuth === false) { // 判断该路由是否需要登录权限 false 为不需要登录
    next();
  } else {
    if (store.state.login) {
      next();
    } else {
      next({ path: '/host/login/alogin' });
    }
  }
  next();
});

router.beforeEach((to, form, next) => {
  next()
});
export default router; 
